import { combineEpics } from 'redux-observable';
import { filter, map, switchMap } from 'rxjs';
import { isOfType } from 'typesafe-actions';
import { catchAxiosError, catchUnauthorizedError, createEpic$ } from 'lib/store';
import { systemUnauthorized } from 'store/system';
import {
  NoteAction,
  noteCreateResponse,
  noteError,
  noteListResponse,
  noteRequest,
  noteResponse,
} from './actions';

const noteCreateEpic$ = createEpic$(({ action$, createNote$ }) =>
  action$.pipe(
    filter(isOfType(NoteAction.CreateRequest)),
    switchMap(action =>
      createNote$(action.payload).pipe(
        map(noteCreateResponse),
        catchAxiosError(noteError),
        catchUnauthorizedError(systemUnauthorized),
      ),
    ),
  ),
);

const noteCreateResponseEpic$ = createEpic$(({ action$ }) =>
  action$.pipe(
    filter(isOfType(NoteAction.CreateResponse)),
    map(action => noteRequest(action.payload.noteId)),
  ),
);

const noteListRequestEpic$ = createEpic$(({ action$, getNoteList$ }) =>
  action$.pipe(
    filter(isOfType(NoteAction.ListRequest)),
    switchMap(action =>
      getNoteList$(action.payload).pipe(
        map(noteListResponse),
        catchAxiosError(noteError),
        catchUnauthorizedError(systemUnauthorized),
      ),
    ),
  ),
);

const noteRequestEpic$ = createEpic$(({ action$, getNote$ }) =>
  action$.pipe(
    filter(isOfType(NoteAction.Request)),
    switchMap(action =>
      getNote$(action.payload).pipe(
        map(noteResponse),
        catchAxiosError(noteError),
        catchUnauthorizedError(systemUnauthorized),
      ),
    ),
  ),
);

export default combineEpics(
  noteCreateEpic$,
  noteCreateResponseEpic$,
  noteListRequestEpic$,
  noteRequestEpic$,
);
